import { Constants } from '../../constants/constants';
import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';

import { EstructuraControlService } from '../../servicios/estructura-control.service';
import { SetFormService } from '../../servicios/set-form.service';
import { FormTextbox } from '../../model-form/form-textbox';
import { FormDropdown } from '../../model-form/form-dropdown';
import { EstructuraBase } from '../../model-form/estructura-base';
import { Utils } from '../../utils/utils';
import { HelperService } from '../../servicios/helper.service';
import { PersonaService } from '../../servicios/persona.service';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-crear-persona',
  templateUrl: './crear-persona.component.html',
  styleUrls: ['./crear-persona.component.css']
})
export class CrearPersonaComponent implements OnInit {
  @ViewChild('resetForm', {static: false}) resetForm: DynamicFormComponent;
  @Output() actualizaPadrePersona = new EventEmitter<any>();
  items: EstructuraBase<any>[];
  descripcion: string;
  idFormulario = 25;
  origenParent = 'creacionpersona';
  parametrosDestino: any[] = [];
  procedimientoDestino: string = '';

  constructor(
    private servicioFormulario: SetFormService,
    public ruta: Utils,
    private formatFormulario: Utils,
    private _helper: HelperService,
    private servicioPersona: PersonaService
  ) {
    this.descripcion = 'Creación De Persona';
    this.crearFormulario();
  }

  crearFormulario() {
    let response: any;
    this.servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
      this.procedimientoDestino = data[0].procedimientoDestino;
      //console.log(JSON.stringify(data));
      response = this.formatFormulario.formatFormulario(data);
      this.items = response.arrayDatos;
      this.parametrosDestino = response.parametros;

      return this.items.sort((a, b) => a.order - b.order);
    });
  }

  ngOnInit() {}

  dataFormulario($event) {
    //alert(JSON.stringify($event));
    const dataForm = $event;
    if (dataForm.parent === this.origenParent) {
      const respuesta = this.validators(dataForm.datos);
    }
  }

  validators(dataForm) {
    const tipoDocumentoArr = this._helper.where(dataForm.infoPayload, {
      key: 'tipoDocumento'
    });

    const numeroDocumentoArr = this._helper.where(dataForm.infoPayload, {
      key: 'numeroDocumento'
    });

    let tipoDocumento: any;
    let numeroDocumento: any;

    tipoDocumento = tipoDocumentoArr;
    numeroDocumento = numeroDocumentoArr;

    this.servicioPersona
      .getPersona(tipoDocumento[0].value, numeroDocumento[0].value)
      .subscribe(data => {        
        if (data.length > 0) {
          Swal.fire({
            title: 'Error Persona',
            text: 'Esta persona ya existe por favor verifique.',
            type: 'error'
          });
        } else {
          this.servicioFormulario.postFormulario(dataForm).subscribe(data => {
            Swal.fire({
              title: this.descripcion,
              text: 'Informacion Almacenada Correctamente.',
              type: 'success'
            });
            this.reset();
            this.actualizaPadrePersona.emit(1);
          });
        }
      });
    return true;
  }

  reset() {
    this.resetForm.resetForm();
  }
}
